import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { Toast } from 'app/shared/toast/toast';
import { PasswordStrengthComponent } from '../../shared/password-strength/password-strength';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-reset-password',
   templateUrl: './reset-password.component.html',
   styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   errorMessage: any;
   forgot_key: any;
   success = false;
   password: any;
   conpassword: any;
   device: string;
   visible = false;
   visibleC = false;
   private username: string;
   private fullname: string;
   minLength: number;
   maxLength: number;
   newError: string;
   loading: boolean;

   constructor(private router: Router, private route: ActivatedRoute,
               private service: IdexService, private toast: Toast,
               private translate: TranslateService) {
   }

   ngOnInit(): void {
      this.route.params.forEach((params: Params) => {
         this.device = params['device'];
      });

      this.route
         .queryParams
         .subscribe(params => {
            // Defaults to 0 if no query param provided.
            this.forgot_key = params['key'] || 0;
            this.checkDevice('idex://resetpw?key=' + this.forgot_key, this.forgot_key);
         });
   }

   // noinspection JSAnnotator
   eval(): void {
      if (this.password) {
         this.pwdStrength.eval(this.password, this.username, this.fullname);
      }
   }

   /**
    *
    * @details : reset password
    */

   resetPassword(newpassword: any) {

      this.service.resetPassword(newpassword, this.forgot_key)
         .subscribe((data: any) => {
            this.toast.success(data.message);
            this.router.navigate(['/login']);
         } , error => {
            let e = error;
            try {
               e = JSON.parse(error);
            } catch {}
            if (e.status === 401) {
               this.translate.get('timeout').subscribe(s => {
                  this.toast.error(s);
               });
            } else if (e.status === 403) {
               this.toast.error(e.message);
               this.newError = e.message;
               this.loading = false;
            } else {
               this.toast.error(e.message);
               this.newError = e.message;
               this.loading = false;
            }
         });
   }

   /**
    *
    * @details : Check the device being used.
    */

   checkDevice(path, forget_key) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function() {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function () {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=resetpw?key=' + forget_key;
         }, 1000);
      } else {
         this.service.get('/resetpw/' + forget_key)
            .subscribe(data => {
                  this.success = true;
                  this.username = data.username;
                  this.fullname = data.name;
                  this.minLength = data.minLength;
                  this.maxLength = data.maxLength;
               }
               , (error) => {
                  this.toast.error(error.message);
                  this.success = false;
                  this.router.navigate(['/login']);
               });
      }
   }
}
